import { NotificationsStateType } from '../../../../../../components/notifications/types/notificationsStateType';
import { NotificationsVariantType } from '../../../../../../components/notifications/types/notificationsVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { commonStyles } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [NotificationsVariantType.REGULAR]: {
            [NotificationsStateType.READ]: {
                ...commonStyles(FOUNDATIONS, { message: { font_weight: FONT_WEIGHT.font_regular } }),
            },
            [NotificationsStateType.UNREAD]: {
                ...commonStyles(FOUNDATIONS, {}),
            },
        },
    };
};
//# sourceMappingURL=regular.js.map